import { api } from "../api/api";
import ErrorStackParser from "error-stack-parser";
// configs
import { CONSTS } from "./objectConst";
import { reportToSentry } from "../shared/integrations/sentry";
import { HttpRequestError } from "api/httpRequest";

const isThirdPartyExtensionError = (stackTrace) => {
  const result =
    stackTrace.includes("chrome-extension://") &&
    !stackTrace.includes(`chrome-extension://${CONSTS.EXTENSION_ID}`);
  return result;
};

const isExtensionDisabled = (error) => {
  const result =
    error instanceof Error && error.name === "ExtensionNotInstalledError";
  return result;
};

const isMissMatchWithBackend = (error) => {
  const result =
    error instanceof HttpRequestError &&
    error.axios.response &&
    error.axios.response.status === 404;
  return result;
};

export function prepareStackTrace(error) {
  if (isExtensionDisabled() || isMissMatchWithBackend()) {
    window.location.reload();
  }

  if (error.skipLogging) {
    console.warn(error);
    return;
  }
  /** @type {string | undefined} */

  let stackTrace;
  try {
    stackTrace = [...ErrorStackParser.parse(error).map((item) => item.source)]
      .join(" \n ")
      .trim();

    if (isThirdPartyExtensionError(stackTrace)) {
      return;
    }

    reportToSentry(error);
  } catch (e) {
    reportToSentry(error);
    reportToSentry(e);
    return;
  }

  return stackTrace;
}

const logEnjectService = async (error) => {
  const stackTrace = prepareStackTrace(error);

  if (stackTrace) {
    const data = {
      severity: "Error",
      event_id: "AppGenericError",
      message: "Unhandled app error {Message}, {StackTrace},{Version}",
      args: [`${error.name}:${error.message}`, stackTrace, CONSTS.APP_VERSION],
    };

    await api.createLogEnjectService(data);
  }
};

export const helpersFunc = {
  logEnjectServiceCatch: (error) => {
    if (CONSTS.LOGS_SETTINGS.didCatch) {
      logEnjectService(error);
    }
  },
  logEnjectServicePromise: (error) => {
    console.log(error);
    if (CONSTS.LOGS_SETTINGS.rejection) {
      logEnjectService(error);
    }
  },
};
